export const formSchema = {
  type: 'object',
  properties: {
    header: {
      type: 'object',
      properties: {},
    },
    body: {
      type: 'object',
      properties: {},
    },
    footer: {
      type: 'object',
      properties: {},
    },
  },
  mapKey: {
    header: 'header',
    body: 'body',
    footer: 'footer',
  },
  mapName: {
    header: 'header',
    body: 'body',
    footer: 'footer',
  },
  mapTag: {},
  mapField: {
    header: 'header',
    body: 'body',
    footer: 'footer',
  },
}

export const formUischema = {
  type: 'VerticalLayout',
  scope: '#/properties/layout',
  label: '',
  key: 'layout',
  name: 'layout',
  uiType: 'system',
  title: 'System Title',
  cardColor: '#2ed8b6',
  textColor: '#000',
  variant: 'success',
  isShowTitle: true,
  isShowUi: true,
  isCanEdit: true,
  isCanDelete: false,
  isShowField: false,
  elements: [
    {
      type: 'Group',
      scope: '#/properties/header',
      label: '',
      key: 'header',
      name: 'header',
      fieldName: 'header',
      subGroup: false,
      tagname: 'div',
      uiType: 'layout',
      title: 'Header',
      isShowUi: true,
      isCanEdit: true,
      isCanDelete: false,
      isShowField: true,
      elements: [],
    },
    {
      type: 'Group',
      scope: '#/properties/body',
      label: '',
      key: 'body',
      name: 'body',
      fieldName: 'body',
      subGroup: false,
      tagname: 'div',
      uiType: 'layout',
      title: 'Body',
      isShowUi: true,
      isCanEdit: true,
      isCanDelete: false,
      isShowField: true,
      elements: [],
    },
    {
      type: 'Group',
      scope: '#/properties/footer',
      label: '',
      key: 'footer',
      name: 'footer',
      fieldName: 'footer',
      subGroup: false,
      tagname: 'div',
      uiType: 'layout',
      title: 'Footer',
      isShowUi: true,
      isCanEdit: true,
      isCanDelete: false,
      isShowField: true,
      elements: [],
    },
  ],
}

export const pageSchema = {
  type: 'object',
  properties: {
    header: {
      type: 'object',
      properties: {},
    },
    body: {
      type: 'object',
      properties: {},
    },
  },
  mapKey: {
    header: 'header',
    body: 'body',
  },
  mapName: {
    header: 'header',
    body: 'body',
  },
  mapTag: {},
  mapField: {
    header: 'header',
    body: 'body',
  },
}

export const pageUischema = {
  type: 'VerticalLayout',
  scope: '#/properties/layout',
  label: '',
  key: 'layout',
  name: 'layout',
  uiType: 'system',
  title: 'System Title',
  cardColor: '#2ed8b6',
  textColor: '#000',
  variant: 'success',
  isShowTitle: true,
  isShowBoxShadow: true,
  isShowUi: true,
  isCanEdit: true,
  isCanDelete: false,
  isShowField: false,
  elements: [
    {
      type: 'Group',
      scope: '#/properties/header',
      label: '',
      key: 'header',
      name: 'header',
      fieldName: 'header',
      subGroup: false,
      tagname: 'div',
      uiType: 'layout',
      title: 'Header',
      isShowUi: true,
      isCanEdit: true,
      isCanDelete: false,
      isShowField: true,
      elements: [],
    },
    {
      type: 'Group',
      scope: '#/properties/body',
      label: '',
      key: 'body',
      name: 'body',
      fieldName: 'body',
      subGroup: false,
      tagname: 'div',
      uiType: 'layout',
      title: 'Body',
      isShowUi: true,
      isCanEdit: true,
      isCanDelete: false,
      isShowField: true,
      elements: [],
    },
  ],
}

export const widgetSchema = {
  type: 'object',
  properties: {
    header: {
      type: 'object',
      properties: {},
    },
  },
  mapKey: {
    header: 'header',
  },
  mapName: {
    header: 'header',
  },
  mapTag: {},
  mapField: {
    header: 'header',
  },
}

export const widgetUischema = {
  type: 'VerticalLayout',
  scope: '#/properties/layout',
  label: '',
  key: 'layout',
  name: 'layout',
  uiType: 'system',
  title: '',
  cardColor: '#fff',
  textColor: '#000',
  variant: 'success',
  isShowTitle: false,
  isShowBoxShadow: false,
  isShowUi: true,
  isCanEdit: true,
  isCanDelete: false,
  isShowField: false,
  elements: [
    {
      type: 'Group',
      scope: '#/properties/header',
      label: '',
      key: 'header',
      name: 'header',
      fieldName: 'header',
      subGroup: false,
      tagname: 'div',
      uiType: 'layout',
      title: 'Header',
      isShowUi: true,
      isCanEdit: true,
      isCanDelete: false,
      isShowField: true,
      elements: [],
    },
  ],
}

export const dashboardSchema = {
  type: 'object',
  properties: {
    header: {
      type: 'object',
      properties: {},
    },
  },
  mapKey: {
    header: 'header',
  },
  mapName: {
    header: 'header',
  },
  mapTag: {},
  mapField: {
    header: 'header',
  },
}

export const dashboardUischema = {
  type: 'VerticalLayout',
  scope: '#/properties/layout',
  label: '',
  key: 'layout',
  name: 'layout',
  uiType: 'system',
  title: '',
  cardColor: '#fff',
  textColor: '#000',
  variant: 'success',
  isShowTitle: false,
  isShowBoxShadow: false,
  isShowUi: true,
  isCanEdit: true,
  isCanDelete: false,
  isShowField: false,
  elements: [
    {
      type: 'Group',
      scope: '#/properties/header',
      label: '',
      key: 'header',
      name: 'header',
      fieldName: 'header',
      subGroup: false,
      tagname: 'div',
      uiType: 'layout',
      title: 'Header',
      isShowUi: true,
      isCanEdit: true,
      isCanDelete: false,
      isShowField: true,
      elements: [],
      layouts: {},
    },
  ],
}
